(function () {
  var observer;
  var scheduled = false;

 function cartIconMarkup() {
  return (
    '<span class="bl-card-cart-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M3.5 4.5h2.1l1.9 9.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.95-1.55L20.7 8H6.3" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<circle cx="9.5" cy="19" r="1.25" stroke="currentColor" stroke-width="1.9"/>' +
        '<circle cx="17.5" cy="19" r="1.25" stroke="currentColor" stroke-width="1.9"/>' +
      '</svg>' +
    '</span>'
  );
}

  function enhanceProductCards(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.product-card-wrapper').forEach(function (wrapper) {
      var card = wrapper.querySelector('.card');
      var inner = card ? card.querySelector(':scope > .card__inner') : null;
      var quickAdd = card ? card.querySelector(':scope > .card__content .quick-add') : null;

      if (!inner || !quickAdd || quickAdd.dataset.blCartIconReady === 'true') {
        return;
      }

      var button = quickAdd.querySelector('.quick-add__submit');

      if (!button) {
        return;
      }

      quickAdd.dataset.blCartIconReady = 'true';
      button.classList.add('bl-card-cart-button');

      if (!button.querySelector('.bl-card-cart-icon')) {
        button.insertAdjacentHTML('afterbegin', cartIconMarkup());
      }

      inner.appendChild(quickAdd);
    });
  }

  function scheduleEnhancement(root) {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhanceProductCards(root || document);
    });
  }

  function start() {
    enhanceProductCards(document);

    observer = new MutationObserver(function () {
      scheduleEnhancement(document);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleEnhancement(event.target);
  });
})();